(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/podium.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/podium.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const getPodiumImageSrc = () => "".concat(svs.core.config.data.svsconfig.cdn, "/images/tickets/next-gen/podium-shadowed-small.png");
const preloadPodiumImage = () => new Promise(resolve => {
  const preloadImage = new window.Image();
  let isResolved = false;
  const done = () => {
    if (isResolved) {
      return;
    }
    isResolved = true;
    preloadImage.onload = null;
    preloadImage.onerror = null;
    resolve(getPodiumImageSrc());
  };
  preloadImage.onload = done;
  preloadImage.onerror = done;
  preloadImage.src = getPodiumImageSrc();
  if (preloadImage.complete) {
    done();
  }
});
const containerStyle = {
  display: 'block',
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: 0,
  height: 0
};
const containerStyleRelative = {
  position: 'relative',
  width: '100%',
  aspectRatio: '819 / 147'
};

const podiumStyle = {
  position: 'absolute',
  left: '-60px',
  right: '-60px',
  bottom: '0px',
  top: 'auto',
  aspectRatio: '819 / 147',
  backgroundImage: "url(\"".concat(getPodiumImageSrc(), "\")"),
  backgroundSize: 'contain',
  backgroundPosition: 'center bottom',
  backgroundRepeat: 'no-repeat',
  pointerEvents: 'none'
};
const Podium = _ref => {
  let _ref$topOffset = _ref.topOffset,
    topOffset = _ref$topOffset === void 0 ? 5 : _ref$topOffset,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'relative' : _ref$position;
  const marginTop = "".concat(topOffset, "%");
  return React.createElement("div", {
    style: _objectSpread(_objectSpread({}, position === 'relative' ? containerStyleRelative : containerStyle), {}, {
      marginTop
    })
  }, React.createElement("div", {
    style: podiumStyle
  }));
};
setGlobal('svs.tickets.next.components.podium', {
  getPodiumImageSrc,
  preloadPodiumImage
});
setGlobal('svs.tickets.next.components.Podium', Podium);

 })(window);